import { ClaimMiningService } from './ClaimMiningService';
import { StartMiningService } from './StartMiningService';
import { FetchMiningDataService } from './FetchMiningDataService';
// import { BoostMiningService } from './BoostMiningService';
import { useMiningStore } from '../../../Store/miningStore';
import { BoostProviderManager } from '../Provider/Provider';

export class MiningService {
  static async fetchMiningData() {
    try {
      const data = await FetchMiningDataService.fetch();
      const store = useMiningStore.getState();
      
      // Обновляем только если значения действительно изменились
      if (data.last_boost_time !== store.lastBoostTime) {
        store.setLastBoostTime(data.last_boost_time);
      }
      
      if (data.adsgram_ads_allowed !== store.adsgramAdsAllowed) {
        store.setAdsgramAdsAllowed(data.adsgram_ads_allowed);
      }

      return data;
    } catch (error) {
      console.error("Ошибка при получении данных майнинга:", error);
      throw error;
    }
  }

  static async claimMining(miningId: number) {
    return await ClaimMiningService.claim(miningId);
  }

  static async startMining() {
    return await StartMiningService.start();
  }

  static async boostMining(miningId: number) {
    try {
      const providers = BoostProviderManager.getProviders();
      
      for (const provider of providers) {
        try {
          console.log(`Checking boost tasks for provider: ${provider.getName()}`);
          
          const tasks = await provider.getAvailableTasks(miningId);
          
          if (tasks && tasks.length > 0) {
            console.log(`Found ${tasks.length} tasks from ${provider.getName()}`);
            
            // Берем первое доступное задание
            const task = tasks[0];
            
            // Если это задание от Barza, приоритизируем его
            if (provider.getName() === 'Barza') {
              console.log('Found Barza task, using it');
              const success = await task.onClick();
              if (success) {
                await MiningService.fetchMiningData();
                return true;
              }
              continue;
            }
            
            // Для других провайдеров
            const success = await task.onClick();
            if (success) {
              await MiningService.fetchMiningData();
              return true;
            }
          }
        } catch (error) {
          console.error(`Error with provider ${provider.getName()}:`, error);
          continue; // Продолжаем с следующим провайдером при ошибке
        }
      }
      
      return false;
    } catch (error) {
      console.error('Error in MiningService.boostMining:', error);
      throw error;
    }
  }

  static canClaim(status: string) {
    return status === 'claim';
  }

  static canStart(status: string) {
    return status === 'end';
  }
}